// Theme switching for HMS. Light is and stays the default: users who never
// touch the toggle see exactly what they saw before dark mode existed.
//
// The active theme is stamped on <html> as data-theme; CSS reacts via
// [data-theme="dark"] selectors (see tokens.css and darkShell.css).
// Persisted per browser in localStorage.

const STORAGE_KEY = 'hms-theme';

export const getTheme = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
};

export const applyTheme = (theme) => {
  document.documentElement.setAttribute('data-theme', theme === 'dark' ? 'dark' : 'light');
};

export const setTheme = (theme) => {
  try {
    localStorage.setItem(STORAGE_KEY, theme === 'dark' ? 'dark' : 'light');
  } catch {
    // Private-mode storage failures just mean the choice won't persist.
  }
  applyTheme(theme);
  // Let mounted components (e.g. the navbar toggle) refresh their label.
  window.dispatchEvent(new CustomEvent('hmsThemeChanged', { detail: { theme } }));
};

export const toggleTheme = () => {
  const next = getTheme() === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
};

export const initTheme = () => {
  applyTheme(getTheme());
};
